function userType(key, name) {
    return {
        key: key,
        name: name
    };
}

export default function userTypes() {
  return {
    free: userType('free', 'Basic'),
    paid: userType('paid', 'Standard'),
    managed: userType('managed', 'Pro'),

    isFree: function(type) {
      return type === this.free.key;
    },

    isPaid: function(type) {
      return type === this.paid.key;
    },

    isManaged: function(type) {
      return type === this.managed.key;
    }
  };
}



// WEBPACK FOOTER //
// ./data/services/user-types.js